var localeToSelect;
var flatPickrObject;

var periodLabelMap = {
    cn: ['上午', '下午'],
    gr: ['ΠΜ', 'ΜΜ'],
    hu: ['DE', 'DU'],
    jp: ['午前', '午後'],
    tr: ['ÖÖ', 'ÖS'],
    tw: ['上午', '下午'],
};

function normalizeLocale(locale) {
    const localeMap = {
        el: 'gr',
        ja: 'jp',
        'zh-cn': 'cn',
        'zh-hans': 'cn',
        'zh-tw': 'tw',
        'zh-hant': 'tw',
    };

    locale = String(locale || (window.greenmotion && window.greenmotion.locale) || 'en').replace('com-', '').toLowerCase();

    return localeMap[locale] || locale;
}

function getPeriodLabels(locale) {
    const normalizedLocale = normalizeLocale(locale);
    const amPM = periodLabelMap[normalizedLocale] || (localeToSelect && localeToSelect.amPM);

    return {
        AM: amPM && amPM[0] ? amPM[0] : 'AM',
        PM: amPM && amPM[1] ? amPM[1] : 'PM',
    };
}

var greek = {
    weekdays: {
        shorthand: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
        longhand: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
    },
    months: {
        shorthand: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαϊ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
        longhand: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
    },
    firstDayOfWeek: 1,
    rangeSeparator: ' έως ',
    weekAbbreviation: 'Εβδ.',
    scrollTitle: 'Μετακυλήστε για αλλαγή',
    toggleTitle: 'Κάντε κλικ για αλλαγή',
    time_24hr: true,
};

switch (window.greenmotion.locale) {
    case 'ba':
        flatPickrObject = require('flatpickr/dist/l10n/bs');
        localeToSelect = flatPickrObject.Bosnian;
        break;
    case 'bg':
        flatPickrObject = require('flatpickr/dist/l10n/bg');
        localeToSelect = flatPickrObject.Bulgarian;
        break;
    case 'cn':
        flatPickrObject = require('flatpickr/dist/l10n/zh');
        localeToSelect = flatPickrObject.Mandarin;
        break;
    case 'de':
        flatPickrObject = require('flatpickr/dist/l10n/de');
        localeToSelect = flatPickrObject.German;
        break;
    case 'dk':
        flatPickrObject = require('flatpickr/dist/l10n/da');
        localeToSelect = flatPickrObject.Danish;
        break;
    case 'es':
        flatPickrObject = require('flatpickr/dist/l10n/es');
        localeToSelect = flatPickrObject.Spanish;
        break;
    case 'fi':
        flatPickrObject = require('flatpickr/dist/l10n/fi');
        localeToSelect = flatPickrObject.Finnish;
        break;
    case 'fr':
        flatPickrObject = require('flatpickr/dist/l10n/fr');
        localeToSelect = flatPickrObject.French;
        break;
    case 'gr':
        localeToSelect = greek;
        break;
    case 'hr':
        flatPickrObject = require('flatpickr/dist/l10n/hr');
        localeToSelect = flatPickrObject.Croatian;
        break;
    case 'hu':
        flatPickrObject = require('flatpickr/dist/l10n/hu');
        localeToSelect = flatPickrObject.Hungarian;
        break;
    case 'it':
        flatPickrObject = require('flatpickr/dist/l10n/it');
        localeToSelect = flatPickrObject.Italian;
        break;
    case 'jp':
        flatPickrObject = require('flatpickr/dist/l10n/ja');
        localeToSelect = flatPickrObject.Japanese;
        break;
    case 'lt':
        flatPickrObject = require('flatpickr/dist/l10n/lt');
        localeToSelect = flatPickrObject.Lithuanian;
        break;
    case 'lv':
        flatPickrObject = require('flatpickr/dist/l10n/lv');
        localeToSelect = flatPickrObject.Latvian;
        break;
    case 'me':
        flatPickrObject = require('flatpickr/dist/l10n/sr');
        localeToSelect = flatPickrObject.Serbian;
        break;
    case 'mk':
        flatPickrObject = require('flatpickr/dist/l10n/mk');
        localeToSelect = flatPickrObject.Macedonian;
        break;
    case 'mx':
        flatPickrObject = require('flatpickr/dist/l10n/es');
        localeToSelect = flatPickrObject.Spanish;
        break;
    case 'nl':
        flatPickrObject = require('flatpickr/dist/l10n/nl');
        localeToSelect = flatPickrObject.Dutch;
        break;
    case 'pl':
        flatPickrObject = require('flatpickr/dist/l10n/pl');
        localeToSelect = flatPickrObject.Polish;
        break;
    case 'pt':
        flatPickrObject = require('flatpickr/dist/l10n/pt');
        localeToSelect = flatPickrObject.Portuguese;
        break;
    case 'rs':
        flatPickrObject = require('flatpickr/dist/l10n/sr');
        localeToSelect = flatPickrObject.Serbian;
        break;
    case 'se':
        flatPickrObject = require('flatpickr/dist/l10n/sv');
        localeToSelect = flatPickrObject.Swedish;
        break;
    case 'tr':
        flatPickrObject = require('flatpickr/dist/l10n/tr');
        localeToSelect = flatPickrObject.Turkish;
        break;
    case 'tw':
        flatPickrObject = require('flatpickr/dist/l10n/zh-tw');
        localeToSelect = flatPickrObject.MandarinTraditional;
        break;
    default:
        flatPickrObject = require('flatpickr/dist/l10n/default');
        localeToSelect = flatPickrObject.english;
}


export { localeToSelect, getPeriodLabels };
